<ng-container *ngIf="showSpinner">
  <div class="loading">
    <div class="loading__background"></div>
    <div class="loading__icon"></div>
    <div class="loading-wrapper"></div>
  </div>
</ng-container>
